import XLSX from 'xlsx-js-style';

// PDF tasarımıyla uyumlu, renkli ve düzenli Excel çıktısı
const border = { top: { style: 'thin', color: { rgb: 'E2E8F0' } }, bottom: { style: 'thin', color: { rgb: 'E2E8F0' } }, left: { style: 'thin', color: { rgb: 'E2E8F0' } }, right: { style: 'thin', color: { rgb: 'E2E8F0' } } };
const font = (o = {}) => ({ name: 'Calibri', sz: 10, color: { rgb: '1E293B' }, ...o });

export const STATUS_COLORS = {
  'Onaylandı': ['DCFCE7', '166534'], 'Aktif': ['DCFCE7', '166534'],
  'Eksik/Hatalı': ['FEE2E2', '991B1B'], 'Reddedildi': ['FEE2E2', '991B1B'],
  'Süresi Dolmuş': ['FEF3C7', '92400E'], 'İSG İncelemesinde': ['E0F2FE', '075985'],
  'Onay Bekliyor': ['FFEDD5', '9A3412'], 'Taslak': ['F1F5F9', '475569'], 'Pasif': ['F1F5F9', '475569'],
  'Talep Bilgisi Hatalı': ['FEE2E2', '991B1B'], 'Geri Çekildi': ['F1F5F9', '475569'], 'Tamamlandı': ['DBEAFE', '1E40AF'], 'İptal': ['F1F5F9', '475569'],
};

export const writeStyledExcel = ({ fileName, sheetName, title, subtitle, columns, rows, statusKey }) => {
  const n = columns.length;
  const aoa = [[title], [subtitle], columns.map(c => c.header), ...rows.map(r => columns.map(c => r[c.key] ?? '-'))];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: n - 1 } }, { s: { r: 1, c: 0 }, e: { r: 1, c: n - 1 } }];
  ws['!cols'] = columns.map(c => ({ wch: c.width || 16 }));
  ws['!rows'] = [{ hpt: 30 }, { hpt: 18 }, { hpt: 26 }, ...rows.map(r => ({ hpt: Math.max(22, 15 * Math.max(...columns.map(c => String(r[c.key] ?? '').split('\n').length))) }))];
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 2, c: 0 }, e: { r: 2 + rows.length, c: n - 1 } }) };
  ws['!views'] = [{ state: 'frozen', ySplit: 3 }];
  const set = (r, c, s) => { const ref = XLSX.utils.encode_cell({ r, c }); if (!ws[ref]) ws[ref] = { t: 's', v: '' }; ws[ref].s = s; };
  for (let c = 0; c < n; c += 1) {
    set(0, c, { font: font({ sz: 15, bold: true, color: { rgb: 'FFFFFF' } }), fill: { fgColor: { rgb: '0F172A' } }, alignment: { vertical: 'center', horizontal: 'left', indent: 1 } });
    set(1, c, { font: font({ sz: 9, color: { rgb: '475569' } }), fill: { fgColor: { rgb: 'F1F5F9' } }, alignment: { vertical: 'center', horizontal: 'left', indent: 1 } });
    set(2, c, { font: font({ bold: true, color: { rgb: 'FFFFFF' } }), fill: { fgColor: { rgb: '1D4ED8' } }, alignment: { vertical: 'center', horizontal: 'center', wrapText: true }, border });
  }
  rows.forEach((row, i) => {
    const zebra = i % 2 ? 'F8FAFC' : 'FFFFFF';
    columns.forEach((col, c) => {
      const status = col.key === statusKey && STATUS_COLORS[row[col.key]];
      set(3 + i, c, {
        font: font(status ? { bold: true, color: { rgb: status[1] } } : col.bold ? { bold: true } : {}),
        fill: { fgColor: { rgb: status ? status[0] : zebra } },
        alignment: { vertical: 'center', horizontal: col.align || 'center', wrapText: true },
        border,
      });
    });
  });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, fileName);
};
